import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {Modal, Button, Nav, Container, Navbar} from 'react-bootstrap';

function NavigationBar() {
  // Weather temperature state
  const [temperature, setTemperature] = useState('');
  const [city, setCity] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navbarRef = useRef(null);
  const [show, setShow] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Load temperature from localStorage on component mount
  useEffect(() => {
    const storedTemp = localStorage.getItem('temp');
    const storedCity = localStorage.getItem('city');

    if (storedTemp && storedTemp !== '' && storedCity && storedCity !== '') {
      setTemperature(storedTemp);
      setCity(storedCity);
    }
  }, []);

  // Close the navbar if the user clicks outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target) && isNavOpen) {
        setIsNavOpen(false);
      }
    };

    // Add event listener on mount
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isNavOpen]);

  // Weather API call
  const fetchWeatherData = async () => {
    if (!zipCode.trim()) {
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URI}/weather/api/${zipCode}`
      );

      const parsedData = JSON.parse(response.data);
      const temp = Math.trunc(parsedData.list[0].main.temp);
      const cityName = parsedData.city.name;

      // Save to localStorage and update state
      localStorage.setItem('temp', temp.toString());
      localStorage.setItem('city', cityName);

      setTemperature(temp.toString());
      setCity(cityName);
      handleClose();
    } catch (error) {
      alert('Error: Invalid Zipcode Entered!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style jsx="true">{`
        @media (max-width: 991px) {
          .temperature-container {
            display: none !important;
          }
        }
      `}
      </style>
      <Navbar bg="light" data-bs-theme="light" expand="lg" className="bg-body-tertiary navbar navbar-expand-lg navbar-light bg-white py-3 fixed-top shadow-sm">
        <Container>
          <Navbar.Brand href="/">
            <img src="/images/AMRLogo.png" alt="company-logo" width="130"/>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"/>
          <Navbar.Collapse className="justify-content-center" id="basic-navbar-nav">
            <Nav activeKey="/">
              <Nav.Item className={"nav-item px-2 py-2"}>
                <Nav.Link className={"nav-link text-uppercase text-dark nav-home-link"} href="/">Home</Nav.Link>
              </Nav.Item>
              <Nav.Item className={"nav-item px-2 py-2"}>
                <Nav.Link className={"nav-link text-uppercase text-dark nav-fleet-link"} eventKey="link-1" href="/fleet">Fleet</Nav.Link>
              </Nav.Item>
              <Nav.Item className={"nav-item px-2 py-2"}>
                <Nav.Link className={"nav-link text-uppercase text-dark nav-reservation-link"} eventKey="link-2" href="/reservations">Reservation</Nav.Link>
              </Nav.Item>
              <Nav.Item className={"nav-item px-2 py-2"}>
                <Nav.Link className={"nav-link text-uppercase text-dark nav-rates-link"} eventKey="link-2" href="/rates">Rates</Nav.Link>
              </Nav.Item>
              <Nav.Item className={"nav-item px-2 py-2"}>
                <Nav.Link className={"nav-link text-uppercase text-dark nav-team-link"} eventKey="link-2" href="/team">Team</Nav.Link>
              </Nav.Item>
              <Nav.Item className={"nav-item px-2 py-2"}>
                <Nav.Link className={"nav-link text-uppercase text-dark nav-about-us-link"} eventKey="link-2" href="/aboutus">About Us</Nav.Link>
              </Nav.Item>
              <Nav.Item className={"nav-item px-2 py-2"}>
                <Nav.Link className={"nav-link text-uppercase text-dark nav-contact-us-link"} eventKey="link-2" href="/contactus">Contact Us</Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
          <div
              className="order-lg-1 navbar-nav temperature-container"
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '0 10px',
                borderRadius: '4px',
                transition: 'background-color 0.2s ease'
              }}
              onClick={handleShow}
              title="Click to update weather location"
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <p id="displayResult" className="nav-item temperature-value" style={{fontWeight: '500'}}>
              {temperature}
            </p>
            <span style={{marginRight: '5px'}}>&deg;F</span>
            <i
                id="openDialog"
                className="nav-item fas fa-solid fa-pen edit-icon"
                style={{
                  color: '#DBA800', // Gold color
                  marginLeft: '5px',
                  fontSize: '14px',
                  textShadow: '0 0 1px rgba(0,0,0,0.2)'
                }}
            ></i>
            <p id="displayCity" className="temperature-value temp-city" style={{fontSize: '14px'}}>
              {city}
            </p>
          </div>
        </Container>
      </Navbar>
      <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter"
             centered size={"sm"}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Search By Zip Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
              type="text"
              id="userInput"
              onChange={(e) => setZipCode(e.target.value)}
              onKeyDown={async (e) => {
                if (e.key === 'Enter') {
                  await fetchWeatherData();
                }
              }}
              placeholder="Enter your Zip Code"
              style={{
                width: '100%',
                padding: '8px',
                marginBottom: '15px',
                borderRadius: '4px',
                border: '1px solid #ced4da'
              }}
              autoFocus
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={fetchWeatherData} disabled={isLoading}>
            {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true">Loading...</span>
                </>
            ) : 'Submit'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NavigationBar;